import React from "react";
import { useSelector } from "react-redux";

import { selectHeatMapMetric } from "../../store/heatmap/HeatMapSelectors";
import HeatMapMetricSelect, {
  isHeatMapMetricDateReliant,
} from "./HeatMapMetricSelect";
import HeatMapDateRangePicker from "./HeatMapDateRangePicker";
import HeatMapColorGradient from "./HeatMapColorGradient";
import { StyledConfigPane } from "./HeatMapModalStyles";

/**
 * Left pane of the Data Visualization modal — three sections:
 * Metric, Date range, Customize gradient.
 *
 * The date range picker is shown only for date-reliant metrics.
 * Inventory (the only non-date-reliant heat map metric) is sourced from
 * product catalog data and doesn't carry a time dimension.
 *
 * Note: The "Other configs" section (minimap / per-tile color bar) is out of
 * scope for this ticket and will be added in a follow-up ticket.
 */
const HeatMapConfigPanel: React.FC = () => {
  const metric = useSelector(selectHeatMapMetric);
  const isDateReliant = isHeatMapMetricDateReliant(metric);

  return (
    <StyledConfigPane>
      <HeatMapMetricSelect />
      {isDateReliant && <HeatMapDateRangePicker />}
      <HeatMapColorGradient />
    </StyledConfigPane>
  );
};

export default HeatMapConfigPanel;
